export const UPDATE_CANVAS_VALUES = 'update_canvas_values'
export const SET_CANVAS_INITED = 'set_canvas_inited'
